import React, { useState } from "react";
import "./../styles/components/Contact.css";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaHome,
  FaList,
  FaRegCommentDots,
  FaArrowRight,
} from "react-icons/fa";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    place: "",
    queryType: "",
    message: "",
  });

  const [phoneError, setPhoneError] = useState("");

  // ✅ Only Render backend
  const API_URL = "https://my-backend-bay.vercel.app/api/sendEmail";

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      if (/^\d{0,10}$/.test(value)) {
        setFormData((prev) => ({ ...prev, phone: value }));
        if (value.length === 10) setPhoneError("");
        else setPhoneError("Mobile number must be exactly 10 digits");
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.phone.length !== 10) {
      setPhoneError("Mobile number must be exactly 10 digits");
      return;
    }

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (data.success) {
        alert("✅ Thank you! Your request has been sent.");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          place: "",
          queryType: "",
          message: "",
        });
      } else {
        alert("❌ Failed to send message. Try again later.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("⚠️ Something went wrong. Please try again.");
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-left">
        <p className="tag">📩 Let’s Catch Up</p>
        <h2>
          Give us a chance to shape your space with care, quality, and trust.{" "}
          <FaArrowRight className="arrow-icon" />
        </h2>
      </div>

      <div className="contact-right">
        <p>Fill the form and we’ll get back to you quickly.</p>

        <form onSubmit={handleSubmit}>
          {/* First Name */}
          <div className="form-group">
            <FaUser className="input-icon" />
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </div>

          {/* Last Name */}
          <div className="form-group">
            <FaUser className="input-icon" />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>

          {/* Email */}
          <div className="form-group">
            <FaEnvelope className="input-icon" />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          {/* Phone */}
          <div className="form-group">
            <FaPhone className="input-icon" />
            <input
              type="tel"
              name="phone"
              placeholder="Mobile No."
              value={formData.phone}
              onChange={handleChange}
              maxLength="10"
              required
            />
          </div>
          {phoneError && <span className="error-msg">{phoneError}</span>}

          {/* Place */}
          <div className="form-group">
            <FaHome className="input-icon" />
            <input
              type="text"
              name="place"
              placeholder="Address"
              value={formData.place}
              onChange={handleChange}
              required
            />
          </div>

          {/* Query Type Dropdown */}
          <div className="form-group">
            <FaList className="input-icon" />
            <select
              name="queryType"
              value={formData.queryType}
              onChange={handleChange}
              required
            >
              <option value="">Select Query Type</option>
              <option value="general">General Query</option>
              <option value="feedback">Feedback</option>
              <option value="complaint">Complaint</option>
              <option value="collaboration">Collaboration</option>
              <option value="other">Other</option>
            </select>
          </div>

          {/* Message */}
          <div className="form-group">
            <FaRegCommentDots className="input-icon" />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          {/* Submit */}
          <button type="submit" className="btn-submit">
            👉 Submit Request
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
